import SimpleLightbox from "simplelightbox";
import GLightbox from "glightbox";
export function lightbox() {
  //new simpleLightbox(".image-gallery a", {});
  //new simpleLightbox(".image-gallery-item", {});

  //foreach image-gallery__item-grid class create lightbox
  const lightbox = document.querySelectorAll(".image-gallery");
  lightbox.forEach((item) => {
    const lightbox = new SimpleLightbox(item.querySelectorAll("a"), {
      //options
      captionsData: "alt",
      captionDelay: 250,
      //showCounter: false,
      //loop: false,
      //scrollbar: false,
    });
  });


  const glightbox = GLightbox({
    selector: '.video-lightbox',
  })


}
